


























import { Component, Vue, Watch,Prop } from 'vue-property-decorator';
import dayjs from "dayjs";
@Component({
    components: {
      
    },
})
export default class headPanel2 extends Vue {
    userInfo:any={};
    public $refs: {
    };
    @Prop({
        default:false
    })
    needCharge:Boolean;
    created() {
    }
    mounted() {
       
        
    }

    logoutFun(){
        if(this.needCharge){
            this.$emit('goBackHome')
            return;
        }
        this.$router.push("/pad/mainPage/index")
    }

   

   
   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/components/pad/headPanel2.vue